import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import RocketLaunchIcon from '@material-ui/icons/FlightTakeoff';

export const releasesRouteRef = createRouteRef();

const releasesPage = PageBlueprint.make({
  params: {
    path: '/releases',
    title: 'Workload Delivery',
    icon: <RocketLaunchIcon fontSize="small" />,
    routeRef: releasesRouteRef,
    loader: () =>
      import('./ReleasePage').then(module => <module.ReleasePage />),
  },
});

export const releasesPlugin = createFrontendPlugin({
  pluginId: 'releases',
  title: 'Workload Delivery',
  icon: <RocketLaunchIcon fontSize="small" />,
  routes: { root: releasesRouteRef },
  extensions: [releasesPage],
});
